import { render } from "./DownCount.vue?vue&type=template&id=249a52ba&scoped=true"
import script from "./DownCount.vue?vue&type=script&lang=js"
export * from "./DownCount.vue?vue&type=script&lang=js"

import "./DownCount.vue?vue&type=style&index=0&id=249a52ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249a52ba"]])

export default __exports__